define("powergen/controllers/setup",
  [],
  function() {
    "use strict";
    var SetupController;

    SetupController = Ember.ObjectController.extend({
      actions: {
        textFieldFocusIn: function(input) {
          return this.setProperties({
            'currentInputName': input.get('fieldName'),
            'currentInputValue': this.get(input.get('fieldName'))
          });
        },
        keyboardInputValueChanged: function(event) {
          this.set(event.inputName, event.inputValue);
          return this.setProperties({
            'currentInputValue': event.inputValue
          });
        },
        done: function() {
          if (this.get('isComplete')) {
            return this.transitionToRoute('instructions');
          }
        }
      },
      currentInputName: void 0,
      currentInputValue: void 0,
      isComplete: (function() {
        var re, userFields, validFields;
        userFields = [this.get('manager.user.firstName'), this.get('manager.user.lastName'), this.get('manager.user.email')];
        validFields = userFields.map(function(field) {
          field = field.trim();
          if (field.length > 0 && field !== '') {
            return field;
          } else {
            return null;
          }
        });
        validFields = validFields.compact();
        if (validFields.length < userFields.length) {
          return false;
        }
        re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
        if (!re.test($.trim(this.get('manager.user.email')))) {
          return false;
        }
        return true;
      }).property('manager.user.firstName', 'manager.user.lastName', 'manager.user.email')
    });


    return SetupController;
  });